<template>
  <!-- <img :src="imgSrc" /> -->
  <div id="qrcode"></div>
</template>

<script>
  import QRCode from "qrcodejs2"; //引入生成二维码插件

  export default {

    props:{
      msg:String,

    },
    data(){
      return {
        // imgSrc:null,
      }
    },
    methods:{
    	crateQrcode:function(){
    		let qrcode = new QRCode('qrcode',{
    			width:100,
    			height:100,
    			text:this.msg,
    			correctLevel : QRCode.CorrectLevel.H
    		});
    		
    	}

    },
    mounted(){
      this.$nextTick(() => {
	      this.crateQrcode()
	  	})
    }

  }
</script>

<style>
#qrcode{
	position: relative;
	top: 50%;
	width:1.4rem;
	height: 1.4rem;
}
#qrcode img{
	position: absolute;
	top:374.5%;
	left: 400%;
	padding: 5px;
	border-radius: 5px;
	background:#fff;
	box-shadow: 0 1px 3px rgba(0,0,0,.5)
}
</style>


// WEBPACK FOOTER //
// src/components/qrCode.vue